<template>
        <div class="d-flex align-items-center   ">
            <div class="chart_box">
                <label for="size_mm">Size in mm</label>
                <div class="select_block">
                    <select v-model="size" class="custom-select" id="size_mm">
                        <option value="1">47</option>
                        <option value="2">48</option>
                        <option value="3">49</option>
                        <option value="4">50</option>
                        <option value="5">51</option>
                        <option value="6">52</option>
                        <option value="7">53</option>
                        <option value="8">54</option>
                        <option value="9">55</option>
                        <option value="10">56</option>
                        <option value="11">57</option>
                        <option value="12">58</option>
                        <option value="13">59</option>
                        <option value="14">60</option>
                        <option value="15">61</option>
                        <option value="16">62</option>
                        <option value="17">63</option>
                        <option value="18">64</option>
                        <option value="19">65</option>
                        <option value="20">66</option>
                        <option value="21">68</option>
                        <option value="22">69</option>
                    </select>
                </div>
            </div>
            <div class="chart_box">
                <label for="us_size">US Size</label>
                <div class="select_block">
                    <select v-model="size" class="custom-select" id="us_size">
                        <option value="1">3.75</option>
                        <option value="2">4.25</option>
                        <option value="3">4.75</option>
                        <option value="4">5.25</option>
                        <option value="5">5.5</option>
                        <option value="6">5.75</option>
                        <option value="7">6.25</option>
                        <option value="8">6.75</option>
                        <option value="9">7.25</option>
                        <option value="10">7.5</option>
                        <option value="11">8</option>
                        <option value="12">8.25</option>
                        <option value="13">8.5</option>
                        <option value="14">9</option>
                        <option value="15">9.5</option>
                        <option value="16">9.75</option>
                        <option value="17">10</option>
                        <option value="18">10.5</option>
                        <option value="19">11</option>
                        <option value="20">11</option>
                        <option value="21">12</option>
                        <option value="22">12.5</option>
                    </select>
                </div>
            </div>
        </div>  
</template>

<script setup>
    const size = ref(1)
</script>

<style scoped>
.chart_box {
    width: 30%;
    margin-right: 2%;
}
.chart_box label {
    font-size: 14px;
    font-weight: 600;
}

@media(max-width: 767px){
    .chart_box {
        width: 50%;
    }
}
</style>